// extracted by mini-css-extract-plugin
module.exports = {"root":"Fields_root__35FlY","fields":"Fields_fields__1AeSr","column":"Fields_column__3C7qN"};